import { createContext, useContext, useEffect, useMemo, useState } from "react";

import { useEventCallback } from "../hooks/useEventCallback";
import { SubscriberRegistry } from "../services/subscriber-registry/SubscriberRegistry";

interface ISidePanelContext {
    subscriberRegistry: SubscriberRegistry;
}

const SidePanelContext = createContext<ISidePanelContext>(undefined as never);

export const SidePanelContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [subscriberRegistry] = useState(new SubscriberRegistry());
    const contextValue = useMemo((): ISidePanelContext => ({ subscriberRegistry }), [subscriberRegistry]);

    return <SidePanelContext.Provider value={contextValue}>{children}</SidePanelContext.Provider>;
};

export function useTopLevelSidePanel(isOpen: boolean, onClose: () => void): void {
    const { subscriberRegistry } = useContext(SidePanelContext);

    const handleClose = useEventCallback(onClose);
    useEffect(() => {
        if (isOpen) {
            subscriberRegistry.broadcast();

            return subscriberRegistry.subscribe(handleClose);
        }
    }, [isOpen, subscriberRegistry, handleClose]);
}
